<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Passive Aggressive Notes: Painfully Polite and Hilariously Hostile Writings</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<h2 class="FMTitle"><span>Contents</span></h2>
<p class="tocSb"><span><span href="#/xhtml/Cover" title="Link target outside of Sample"><span class="small">COVER</span></span></span></p>
<p class="toc"><span><span href="#/xhtml/Title" title="Link target outside of Sample"><span class="small">TITLE PAGE</span></span></span></p>
<p class="toc"><span><span href="#/xhtml/Dedication" title="Link target outside of Sample"><span class="small">DEDICATION</span></span></span></p>
<p class="toc"><span><a id="fm1"></a><span href="#/xhtml/Epigraph#fm1a" title="Link target outside of Sample"><span class="small">EPIGRAPH</span></span></span></p>
<p class="toc1"><span><a id="ch1"></a><span href="#/xhtml/Chapter001#ch1a" title="Link target outside of Sample"><span class="small">BACK STORY</span></span></span></p>
<p class="toc"><span><a id="ch2"></a><span href="#/xhtml/Chapter002#ch2a" title="Link target outside of Sample"><span class="small">THE NOTES</span></span></span></p>
<p class="toc"><span><a id="ch3"></a><span href="#/xhtml/Chapter003#ch3a" title="Link target outside of Sample"><span class="small">CO-CONSPIRATORS</span></span></span></p>
<p class="toc1"><span><a id="ata"></a><span href="#/xhtml/Abouttheauthor#ataa" title="Link target outside of Sample"><span class="small">ABOUT THE AUTHOR</span></span></span></p>
<p class="toc"><span><a id="prai"></a><span href="#/xhtml/Praise#prai1" title="Link target outside of Sample"><span class="small">PRAISE</span></span></span></p>
<p class="toc"><span><a id="cpy"></a><span href="#/xhtml/Copyright#cpya" title="Link target outside of Sample"><span class="small">COPYRIGHT</span></span></span></p>
<p class="toc"><span><a id="abtp"></a><span href="#/xhtml/Aboutthepublisher#abtp1" title="Link target outside of Sample"><span class="small">ABOUT THE PUBLISHER</span></span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?64ef8604